import ReactPixel from 'react-facebook-pixel';
import TikTok from './tiktok';
// import LinkedIn from './linkedin';
import Reddit from './reddit';
import Twitter from './twitter';
import FB2 from './facebookWithoutContractTracking';
import GoogleTracking from './google';
import { trackDeskConversion } from './trackdesk';
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
};


export const ACTIVATE_PATHS = [
  "alternatives",
  "api",
  "blog",
  "deals",
  "electric-signature-legality",
  "embedding",
  "gsuite-addon",
  "mobile",
  "online-signature",
  "pricing",
  "affiliate-partners",
  "privacy-policy",
  "refund-policy",
  "terms-of-service",
  "enterprise",
  "reviews",
  "soc",
  "whitelabel",
  "wordpress-integration",
  "thank-you",
  "customers",
  "about",

]

let isActivatePixel = false
if (typeof window !== "undefined") {
  const url = window.location.href
  console.log(url, '==============');

  isActivatePixel = ACTIVATE_PATHS.some(str1 => {
    // console.log(str1, url, url.includes(str1))
    return url.includes(str1)
  }) || url == "http://localhost:3001/" || url == "https://www.boloforms.com/"

}

class FB {
  constructor(email) {
    this.pixel = ReactPixel;
    let gtmLocationData = JSON.parse(localStorage.getItem("gtmLocationData"));
    // console.log(gtmLocationData, "===============")
    this.pixel.init(
      process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID,
      {
        em: email,
        ct: gtmLocationData?.city,
        st: gtmLocationData?.region,
        zp: gtmLocationData?.postal,
        country: gtmLocationData?.country,
        // db: gtmLocationData?.region,
        // em: gtmLocationData?.email,
        // fn: gtmLocationData?.name,
        // ge: gtmLocationData?.ge,
        // ln: gtmLocationData?.ln,
        // ph: gtmLocationData?.ph,
      }, options
    );

    this.pixel.pageView();
    // adding tiktok to this directly
    this.tiktok = new TikTok(email)
    // this.linkedin = new LinkedIn()
    this.reddit = new Reddit()


    if (isActivatePixel)
      this.fb2 = new FB2(email)

    this.google = new GoogleTracking()

    // this.twitter = new Twitter(email)
  }

  trackPurchase(product, priceId, quantity, value) {
    console.log(product, priceId, quantity, value)
    this.pixel.track('Purchase', {
      value: value,
      num_items: quantity,
      currency: 'USD',
      content_ids: [priceId],
      content_name: product,
    });

    // adding tiktok to this directly
    this.tiktok.trackPurchase(product, priceId, quantity, value)
    // this.linkedin.trackPurchase(product, priceId, quantity, value)
    this.reddit.trackPurchase(product, priceId, quantity, value)

    // this.twitter.trackPurchase(product, priceId, quantity, value)
    if (isActivatePixel)
      this.fb2.trackPurchase(product, priceId, quantity, value)

    this.google.trackPurchase(product, priceId, quantity, value)

    trackDeskConversion("sale", value)

  }

  trackInitiateCheckout(product, priceId, quantity, value,) {
    console.log(product, priceId, quantity, value)
    this.pixel.track('InitiateCheckout', {
      value: value,
      num_items: quantity,
      currency: 'USD',
      content_category: product,
      content_ids: [priceId],

    });

    // adding tiktok to this directly
    this.tiktok.trackInitiateCheckout(product, priceId, quantity, value)
    // this.linkedin.trackInitiateCheckout(product, priceId, quantity, value)
    this.reddit.trackInitiateCheckout(product, priceId, quantity, value)

    // this.twitter.trackInitiateCheckout(product, priceId, quantity, value)

    if (isActivatePixel)
      this.fb2.trackInitiateCheckout(product, priceId, quantity, value)

    this.google.trackInitiateCheckout(product, priceId, quantity, value)
  }


  trackAddPaymentInfo(product, priceId, quantity, value) {
    console.log(product, priceId, quantity, value)
    this.pixel.track('AddPaymentInfo', {
      value: value,
      num_items: quantity,
      currency: 'USD',
      content_category: product,
      content_ids: [priceId],

    });

    // adding tiktok to this directly
    this.tiktok.trackAddPaymentInfo(product, priceId, quantity, value)
    // this.linkedin.trackAddPaymentInfo(product, priceId, quantity, value)
    if (isActivatePixel)
      this.fb2.trackAddPaymentInfo(product, priceId, quantity, value)


  }


  trackCustom(event, data) {
    this.pixel.track(event, data);
    this.tiktok.trackCustom(event, data)
    // this.linkedin.trackCustom(event, data)
    this.reddit.trackCustom(event, data)
    // this.twitter.trackCustom(event, data)
    if (isActivatePixel)
      this.fb2.trackCustom(event, data)

  }


  trackSignUp(email, value) {
    this.pixel.track('StartTrial', {
      currency: 'USD',
      value: value ?? 99,
      predicted_ltv: 250,
    })

    if (isActivatePixel)
      this.fb2.trackSignUp(email, value)

  }


}


export default FB

